(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityDetailController', ModalityDetailController);

    ModalityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Modality', 'Patient', 'Corporation'];

    function ModalityDetailController($scope, $rootScope, $stateParams, previousState, entity, Modality, Patient, Corporation) {
        var vm = this;

        vm.modality = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:modalityUpdate', function(event, result) {
            vm.modality = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
